import { Card, CardContent } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { MarkdownRender } from "@/components/ui/markdown-render";

export function Terms() {
  const { data: markdown, isLoading, error } = useQuery({
    queryKey: ["terms-of-service-markdown"],
    queryFn: async () => {
      const res = await fetch("/api/docs/terms-of-service");
      if (!res.ok) throw new Error("Failed to load Terms of Service");
      return res.text();
    },
  });

  return (
    <div className="container max-w-3xl mx-auto py-12">
      <Card>
        <CardContent>
          {isLoading && <div>Loading...</div>}
          {error && <div className="text-red-500">Failed to load Terms of Service.</div>}
          {markdown && <MarkdownRender content={markdown} />}
        </CardContent>
      </Card>
    </div>
  );
}
